import { React, _n } from 'pexui';
import { YodleeBasePage } from './yodleebase';
import { Html } from '../comps/html';

export default class YodleeOptOut extends YodleeBasePage{
    getTitle() {
        return _n('yodlee.optout.title');
    }

    hasFooter(){
        return true;
    }

    getFooterButtons(){
        return [
            {
                label: _n('yodlee.optout.cancel'),
                isPrimary: false,
                onClick: () => this.props.widget.onClose()
            },
            {
                label: _n('yodlee.optout.enroll'),
                isPrimary: true,
                onClick: () => this.props.widget.nav('yodleeSubmit')
            }
        ];
    }

    renderContent() {
        return (
            <Html
                className='infw-yodlee-how-container2'
                content={_n('yodlee.optout.description')} />
        );
    }
}



// WEBPACK FOOTER //
// ./application/src/views/yodlee/yodleeoptout.js